import { useCore } from "@hooks/useCore"
import React from "react"
import LearnPageItemMobile from "./LearnPageItemMobile"
import LearnPageItemDesktop from "./LearnPageItemDesktop"
import { Box } from "@chakra-ui/react"
export interface LearnPageItemProps {
  page: NormalisedArticle
  handleTrackingClick?: VoidFunction
}

const LearnPageItem = (props: LearnPageItemProps) => {
  const {
    helpers: { ErrorBoundary },
  } = useCore()

  return (
    <React.Suspense fallback={<div />}>
      <ErrorBoundary>
        <Box display={["block", "none"]}>
          <LearnPageItemMobile {...props} />
        </Box>
        <Box display={["none", "block"]}>
          <LearnPageItemDesktop {...props} />
        </Box>
      </ErrorBoundary>
    </React.Suspense>
  )
}

export default React.memo(LearnPageItem)
